<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.newDocument") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>{{ $t("product.docTitle") }}</th>
            <td>
              <input
                type="text"
                v-model="form.docTitle"
                class="int_type01 mgt_seltype"
                style="width: 99.8%;"
                name="docTitle"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.docDesc") }}</th>
            <td>
              <input
                type="text"
                v-model="form.docDesc"
                class="int_type01 mgt_seltype"
                style="width: 92%;"
                name="docDesc"
                v-validate="'required'"
              />
              <button @click="parseDesc" class="searchBtn btn btn-primary btn-sm m-1" style="font-size: 16px;">
              Parse
              </button>
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.language") }}</th>
            <td>
              <select
                v-model="form.lang"
                class="int_type01 mgt_seltype"
                v-validate="'required'"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option
                  v-for="(lang, index) in langList"
                  :key="index"
                  :value="lang.codeId"
                >
                  {{ lang.codeName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.documentType") }}</th>
            <td>
              <ul class="group_sel_ul">
                <li>
                  <em>{{ $t("management.mainCategory") }}</em>
                  <select
                    v-model="form.doctypeId"
                    class="int_type01 mgt_seltype"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(doc, index) in docTypeList"
                      :key="index"
                      :value="doc.doctypeId"
                    >
                      {{ doc.doctypeName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("product.prodCode") }}</em>
                  <select
                    v-model="form.modelcodeId"
                    class="int_type01 mgt_seltype"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(mc, index) in modelcodeList"
                      :key="index"
                      :value="mc.modelcodeId"
                    >
                      {{ mc.modelcodeName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("management.exhaustCertification") }}</em>
                  <select
                    v-model="form.exhaustCertiId"
                    class="int_type01 mgt_seltype"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(ex, index) in ecList"
                      :key="index"
                      :value="ex.exhaustCertiId"
                    >
                      {{ ex.exhaustCertiName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.productType") }}</th>
            <td colspan="5">
              <ul class="group_sel_ul">
                <li>
                  <em>{{ $t("management.mainCategory") }}</em>
                  <select
                    v-model="form.upperProdId"
                    class="int_type01 mgt_seltype"
                    @change="getSubProducts(form.upperProdId)"
                    v-validate="'required'"
                  >
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(prod, index) in mainProd"
                      :key="index"
                      :value="prod.prodId"
                    >
                      {{ prod.prodName }}
                    </option>
                  </select>
                </li>
                <li>
                  <em>{{ $t("management.subCategory") }}</em>
                  <select v-model="form.prodId" class="int_type01 mgt_seltype">
                    <option value="">--{{ $t("common.all") }}--</option>
                    <option
                      v-for="(subProd, index) in subProductType"
                      :key="index"
                      :value="subProd.prodId"
                    >
                      {{ subProd.prodName }}
                    </option>
                  </select>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <th>{{ $t("product.model") }}</th>
            <td>
              <div class="d-flex">
                <div class="w-50">
                  <autocomplete
                    :source="modelList"
                    input-class="autocomplete-input mgt_seltype"
                    ref="autocomplete"
                    @selected="validateSelection"
                    @results="getInputValue"
                    placeholder="Search a Model"
                    @clear="clearModel"
                  >
                  </autocomplete>
                </div>
                <div>
                  <button
                    type="button"
                    class="tbl_add_bt"
                    style="height: 34px; width: 34px"
                    @click="addModel"
                  >
                    Add
                  </button>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span>Selected Value : </span>
                </div>
                <div style="margin-left: 10px; margin-top: 5px">
                  <span v-for="(item, index) in form.modelNameList" v-bind:key="item" @click="deleteModel(index)" style="margin-right: 10px; cursor: pointer;" title="Click to delete">{{ item }}</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="mgt_option_bottom">
        <button @click="regist()" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <router-link
          to="/management/library/document"
          class="btn btn-outline-dark"
          style="margin-left: 10px"
          >{{ $t("common.list") }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import router from "@/routes/index";
import Autocomplete from "vuejs-auto-complete";
import { newdocumentList, documentUpdate, getDataParser, } from "@/api/document";
export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      docTypeList: [],
      mainProd: [],
      subProd: [],
      langList: [],
      ecList: [],
      modelcodeList: [],
      form: {
        docTitle: "",
        docDesc: "",
        doctypeId: "",
        modelcodeId: "",
        exhaustCertiId: "",
        prodId: "",
        upperProdId: "",
        lang: "",
        modelNameList: [],
      },
      confirmYN: false,
      modelList: [],
      tmpValue: "",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const resp = await newdocumentList();

        this.docTypeList = resp.data.docTypeList;
        this.mainProd = resp.data.mainProd;
        this.subProd = resp.data.subProd;
        this.langList = resp.data.langList;
        this.ecList = resp.data.ecList;
        this.modelcodeList = resp.data.modelcodeList;
        this.modelList = resp.data.modelList;
      } catch (err) {
        console.log(err);
      }
    },
    // 대분류 선택시 중분류
    getSubProducts(prodId) {
      this.form.prodId = "";
      this.subProductType = [];
      for (let i in this.subProd) {
        if (prodId === this.subProd[i].upperProdId) {
          this.subProductType.push(this.subProd[i]);
        }
      }
    },
    async regist() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        this.confirmYN = confirm(this.$t("alert.save"));
        if (this.confirmYN) {
          const resp = await documentUpdate(this.form);
          if (resp.data.status) {
            alert(this.$t("alert.savedSuccessfully"));
            router.push({ name: 'mgmtDocumentDtails', params: { docId: resp.data.docId } });
          } else {
            if(resp.data.reason == 'TITLE') {
               alert(this.$t("alert.duplicateDocTitle"));
            } else {
               alert(this.$t("alert.ErrorPlzcontactManager"));
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 새로운 Model 추가
    addModel() {
      // 빈값과 기존에 있는 값 검사
      for (let j in this.modelList) {
        if (this.modelList[j].name == this.tmpValue || this.tmpValue == "") {
          alert(this.$t("alert.pleaseCheckTheValue"));
          return;
        }
      }
      this.modelList.push({ id: this.modelList.length + 1, name: this.tmpValue });
      this.validateSelection({ display: this.tmpValue });
    },
    validateSelection(selection) {
      if (selection.display != null && !this.form.modelNameList.includes(selection.display)) {
        this.form.modelNameList.push(selection.display);
      }
    },
    clearModel() {
//      this.form.modelName = "";
    },
    // Model 입력할때마다 값 저장
    getInputValue() {
      this.tmpValue = $(".autocomplete-input").val();
      // 양쪽 공백 제거
      this.tmpValue = this.tmpValue.trim();
    },
    deleteModel(index) {
      this.form.modelNameList.splice(index, 1);
    },
    async parseDesc() {
      const response = await getDataParser(this.form);

      console.log(response.data);
      if (response.data.status) {
        this.form.doctypeId = response.data.doctypeId;
        this.form.modelcodeId = response.data.modelcodeId;
        this.form.modelNameList = response.data.modelNameList;
        this.form.exhaustCertiId = response.data.exhaustCertiId;
        this.form.lang = response.data.lang;
        this.form.upperProdId = response.data.prodId;
        this.getSubProducts(this.form.upperProdId);
        this.form.prodId = "";       
//        alert("Parsing the description was successful.");
      } else {
        alert("Failed to parse the description.");
      }      

    },

  },
};
</script>

<style scoped>
.mgt_tbl tbody tr th {
  width: 20%;
}
.mgt_option_bottom {
  border-bottom: 0px;
}
</style>
